export function IsMobile() {
  return window.screen.width < 500;
}
